import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Row } from '@app/components/simple-table/simple-table.component';
import { ReportsMap, Selections } from '@app/interfaces/participants-list.interface';
import { NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { BaseForm } from '@forms/base.form';
import { Employee } from '@models/employee/employee.model';
import { Review } from '@models/performance/review.model';

@Component({
    selector: 'app-form-bulk-review-participants',
    templateUrl: './bulk-review-participants.template.html',
})
export class BulkReviewParticipantsForm extends BaseForm {
    @Output() onSelectedParticpantsChange: EventEmitter<Row[]> = new EventEmitter<Row[]>();
    @Output() onSelectedRevieweesParticpantsListChange: EventEmitter<Map<number, ReportsMap>> = new EventEmitter<
        Map<number, ReportsMap>
    >();
    @Input() review: Review;

    @Input() set reviewees(reviewees: Employee[]) {
        if (!reviewees?.length) {
            return;
        }
        this._reviewees = reviewees;

        //Reset Checkboxes
        this.resetAllCheckboxes();
    }

    get reviewees(): Employee[] {
        return this._reviewees;
    }

    private _reviewees: Employee[] = [];

    revieweeName: string = '';
    isLoading: boolean = false;
    selections: Selections = { self: false, manager: false, peers: false, directReports: false };
    revieweesParticipantsList: Map<number, ReportsMap> = new Map<number, ReportsMap>();

    constructor(
        public auth: AuthService,
        private notify: NotifyService
    ) {
        super();
    }

    private resetAllCheckboxes() {
        this.selections = { self: false, manager: false, peers: false, directReports: false };
    }

    onCheckboxChange(event: MatCheckboxChange): void {
        this.selections[event.source.name as keyof Selections] = event.checked;
        this.selections = JSON.parse(JSON.stringify(this.selections));
    }

    getParticipantName(revieweeName: string): void {
        this.revieweeName = revieweeName;
    }

    updateParticipantList(participantList: Map<number, ReportsMap>): void {
        this.onSelectedRevieweesParticpantsListChange.emit(participantList);
    }

    updateParticipantTableList(participantTableList: Row[]) {
        this.onSelectedParticpantsChange.emit(participantTableList);
    }
}
